import { bemBuilder } from "@chatfood/core-utils";

const className = "layouts-mobile-app";

export const css = bemBuilder(className);
export const cssq = bemBuilder(className, true);
